<!-- Filter Modal Backdrop -->
<div
  *ngIf="isVisible"
  class="modal-backdrop"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="filter-modal-title"
>
  <!-- Filter Modal -->
  <div class="filter-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 id="filter-modal-title" class="modal-title">Filters</h2>
        <button class="close-button" (click)="onClose()" aria-label="Close filter modal">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="filters-container">
        <!-- Status Filter -->
        <div class="filter-section">
          <h3 class="filter-title">Status</h3>
          <div class="filter-options">
            <ng-container
              *ngTemplateOutlet="statusRow; context: { items: statuses.slice(0, 2) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="statusRow; context: { items: statuses.slice(2, 4) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="statusRow; context: { items: statuses.slice(4, 5) }"
            ></ng-container>
          </div>
        </div>

        <!-- Campaign Type Filter -->
        <div class="filter-section">
          <h3 class="filter-title">Campaign Type</h3>
          <div class="filter-options">
            <ng-container
              *ngTemplateOutlet="campaignTypeRow; context: { items: campaignTypes.slice(0, 2) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="campaignTypeRow; context: { items: campaignTypes.slice(2, 4) }"
            ></ng-container>
          </div>
        </div>

        <!-- Location Filter -->
        <div class="filter-section">
          <h3 class="filter-title">Location</h3>
          <div class="filter-options">
            <ng-container
              *ngTemplateOutlet="locationRow; context: { items: locations.slice(0, 2) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="locationRow; context: { items: locations.slice(2, 4) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="locationRow; context: { items: locations.slice(4, 6) }"
            ></ng-container>
          </div>
        </div>

        <!-- Sort By Filter
        <div class="filter-section">
          <h3 class="filter-title">Sort By</h3>
          <div class="sort-options">
            <div *ngFor="let sortOption of sortOptions; trackBy: trackByValue" class="radio-item">
              <div class="radio-wrapper">
                <mat-radio-button 
                  [ngModel]="sortOption.selected" 
                  [value]="sortOption.value"
                  
                  (change)="onSortChange(sortOption)"
                ></mat-radio-button>
                <label [for]="'sort-' + sortOption.value" class="radio-label">{{ sortOption.label }}</label>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Modal Footer -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      secondaryText="Clear Filters"
      primaryText="Apply Filters"
      [secondaryDisabled]="!hasActiveFilters()"
      [cancelDesktopOnly]="true"
      (secondaryClick)="onClearFilters()"
      (cancelClick)="onCancel()"
      (primaryClick)="onApplyFilters()"
    />
  </div>
</div>

<!-- Location Filter Row Template (reused for each pair of location checkboxes) -->
<ng-template #locationRow let-items="items">
  <div class="filter-row">
    <div *ngFor="let location of items; trackBy: trackByIndex" class="checkbox-item">
      <div class="checkbox-wrapper">
        <mat-checkbox
          [ngModel]="location.checked"
          [checked]="true"
          (change)="onLocationChange(location)"
        ></mat-checkbox>
        <label [for]="'location-' + location.value" class="checkbox-label">{{
          location.label
        }}</label>
      </div>
    </div>
  </div>
</ng-template>

<!-- Status Filter Row Template (reused for each slice of status checkboxes) -->
<ng-template #statusRow let-items="items">
  <div class="filter-row">
    <div *ngFor="let status of items; trackBy: trackByIndex" class="checkbox-item">
      <div class="checkbox-wrapper">
        <mat-checkbox [(ngModel)]="status.checked" [checked]="true"></mat-checkbox>
        <label [for]="'status-' + status.value" class="checkbox-label">{{ status.label }}</label>
      </div>
    </div>
  </div>
</ng-template>

<!-- Campaign Type Filter Row Template (reused for each slice of campaign type checkboxes) -->
<ng-template #campaignTypeRow let-items="items">
  <div class="filter-row">
    <div *ngFor="let type of items; trackBy: trackByIndex" class="checkbox-item">
      <div class="checkbox-wrapper">
        <mat-checkbox [(ngModel)]="type.checked" [checked]="true"></mat-checkbox>
        <label [for]="'type-' + type.value" class="checkbox-label">{{ type.label }}</label>
      </div>
    </div>
  </div>
</ng-template>
